import React from 'react'
import logo from '../assets/appnexts_1.png'
import { Link } from 'react-router-dom'
import { FaBuilding, FaEnvelope, FaFacebook, FaLinkedin, FaYoutube } from 'react-icons/fa'
const Footer = () => {
  return (
    <footer className="bg-[#f7f8fdec] py-12 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-24">
            <div className="space-y-4">
               <img src={logo}  alt='Logo' className='h-16 '/>
              <p className="text-gray-500 text-sm">
              AppNexts is a renowned international software development company. We specialize in providing custom software development solutions to businesses worldwide. </p>
      </div>
            <div>
              <h3 className="text-lg font-semibold mb-4 text-[#504e9a]">Main Menu</h3>
              <ul className="space-y-2 text-gray-500 font-semibold">
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/">Home</Link></li>
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/about-us">About Us</Link></li>
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/portfolio-grid">Portfolio</Link></li>
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/our-services">Our Service</Link></li>
               <li className=' transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4 text-[#504e9a]">Quick Links</h3>
              <ul className="space-y-2 text-gray-500 font-semibold">
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/terms-and-conditions">Terms and Conditions</Link></li>
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/privacy-policy">Privacy Policy</Link></li>
               <li className=' transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/faqs">FAQs</Link></li>
               <li className=' transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="/our-team-members">Our Team</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4 text-[#504e9a]">Contact Us</h3>
              <ul className="space-y-2 text-gray-500 font-semibold">
               <li className='transition-all duration-100 hover:text-[#4898a5] flex gap-3'>
                
                <FaBuilding  className='text-xl'/>
                AppNexts</li>
               <li className='transition-all duration-100 hover:text-[#4898a5]'>
                <Link to="mailto:info@solutionsoul.com" className='flex gap-3'>
                <FaEnvelope className='text-xl ' />
                info@appnexts.com</Link></li></ul>
                <ul className='text-gray-500 font-semibold flex gap-3 mt-3'>
                <li >
                <Link to="https://www.youtube.com/@AppNexts" target='_blank' rel="noopener noreferrer">
                <FaYoutube  className='text-red-500 text-3xl'/></Link></li>
              <li >
                <Link to="https://www.linkedin.com/company/appnexts" target='_blank' rel="noopener noreferrer">
                <FaLinkedin className='text-blue-500 text-3xl'/></Link></li>
              <li >
                <Link to="https://www.facebook.com/profile.php?id=61568551576819" target='_blank' rel="noopener noreferrer">
                <FaFacebook className='text-indigo-600 text-3xl'/></Link></li></ul>
              
            </div>

          </div>
          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">Copyright © 2025 AppNexts. All rights reserved.</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <Link to="/privacy-policy" className="text-gray-500 text-sm hover:text-gray-700">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="text-gray-500 text-sm hover:text-gray-700">
              Terms and Conditions
              </Link>
            </div>
          </div>
        </div>
      </footer>
  )
}

export default Footer

// import React from "react";
// import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter } from "react-icons/bs";
// import { Link } from "react-router-dom";
// import appnexts_logo from "../assets/appnexts_1.png"
// export default function Footer() {
//   return (
//     <footer className="bg-[#0B1B2B] text-white py-12">
//       <div className="container mx-auto px-4">
//         {/* Top Section */}
//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12">
//           {/* Left Column */}
//           <div className="lg:col-span-4">
//             <img
//               src={appnexts_logo}
//               alt="VentureDive"
//               width={200}
//               height={40}
//               className="mb-6"
//             />
//             <p className="text-gray-300 mb-6 max-w-md">
//               Stay ahead in the rapidly changing world. Take bold steps forward in digital transformation, emerging
//               technologies, scalable systems and custom-built software that helps our clients extract 360° value from
//               business.
//             </p>
//             <button className="bg-[#5f5ca8] text-white px-6 py-3 rounded hover:bg-[#504e9a] transition-colors">
//               Let's get to work
//             </button>
//           </div>

//           {/* Right Columns */}
//           <div className="lg:col-span-8">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {/* Trusted By Column */}
//               <div>
//                 <h3 className="text-lg font-semibold mb-4">Trusted By</h3>
//                 <ul className="space-y-3">
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Startups
//                     </Link>
//                   </li>
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Enterprises
//                     </Link>
//                   </li>
//                 </ul>
//               </div>

//               {/* Services Column */}
//               <div>
//                 <h3 className="text-lg font-semibold mb-4">Services</h3>
//                 <ul className="space-y-3">
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Custom Software Development
//                     </Link>
//                   </li>
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Design Studio
//                     </Link>
//                   </li>
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Digital Transformation
//                     </Link>
//                   </li>
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Cloud Services
//                     </Link>
//                   </li>
//                 </ul>
//               </div>

//               {/* Company Column */}
//               <div>
//                 <h3 className="text-lg font-semibold mb-4">Company</h3>
//                 <ul className="space-y-3">
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       About us
//                     </Link>
//                   </li>
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Careers
//                     </Link>
//                   </li>
//                   <li>
//                     <Link href="#" className="text-gray-300 hover:text-white">
//                       Blog
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/contact-us" className="text-gray-300 hover:text-white">
//                       Contact us
//                     </Link>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>


//         {/* Bottom Section */}
//         <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-700">
//           <p className="text-gray-400 mb-4 md:mb-0">© 2025 Appnexts. All rights reserved.</p>
//           <div className="flex gap-4">
//             <Link to="#" className="text-gray-400 hover:text-white">
//               <BsFacebook className="w-5 h-5" />
//             </Link>
//             <Link to="#" className="text-gray-400 hover:text-white">
//               <BsInstagram className="w-5 h-5" />
//             </Link>
            
//             <Link to="#" className="text-gray-400 hover:text-white">
//               <BsLinkedin className="w-5 h-5" />
//             </Link>
//           </div>
//         </div>
//       </div>
//     </footer>
//   )
// }